import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { Fragment, type PropsWithChildren, type ReactNode, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

interface Props {
    trigger: ReactNode;
}

export function Tooltip({ trigger, children }: PropsWithChildren<Props>) {
    const [ isOpen, setIsOpen ] = useState(false);
    const [ position, setPosition ] = useState({ top: 0, left: 0 });
    const triggerRef = useRef<HTMLButtonElement>(null);
    const [ mounted, setMounted ] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);
    // Compute trigger element's position whenever the tooltip opens.
    useEffect(() => {
        if (isOpen && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            // Position the tooltip below the trigger element, centered horizontally.
            const top = window.scrollY + rect.bottom + 8; // 8px offset from the bottom
            const left = window.scrollX + rect.left + rect.width / 2;
            setPosition({ top, left });
        }
    }, [ isOpen ]);
    const tooltipContent = (
        <Transition
            as={Fragment}
            show={isOpen}
            enter='transition duration-200 ease-out'
            enterFrom='transform opacity-0 translate-y-1'
            enterTo='transform opacity-100 translate-y-0'
            leave='transition duration-100 ease-in'
            leaveFrom='transform opacity-100 translate-y-0'
            leaveTo='transform opacity-0 translate-y-1'
        >
            <PopoverPanel
                static
                onMouseEnter={() => setIsOpen(true)}
                onMouseLeave={() => setIsOpen(false)}
                onClick={() => setIsOpen(!isOpen)}
                className='absolute z-10 px-3 py-2 mt-2 w-auto max-w-lg text-sm text-gray-700 bg-white border border-gray-300 rounded shadow-lg
                     dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600'
                style={{
                    position: 'absolute',
                    top: position.top,
                    left: position.left,
                    transform: 'translate(-50%, 0)'
                }}
            >
                {children}
            </PopoverPanel>
        </Transition>
    );
    return (
        <>
            <Popover className='relative inline-block'>
                <PopoverButton
                    as='span'
                    onMouseEnter={() => setIsOpen(true)}
                    onMouseLeave={() => setIsOpen(false)}
                    ref={triggerRef}
                    className='focus:outline-none'
                >
                    {trigger}
                </PopoverButton>
                {mounted && ReactDOM.createPortal(tooltipContent, document.body)}
            </Popover>
        </>
    );
    // return (
    //     <>
    //         {trigger}
    //         <div className="absolute invisible z-10 inline-block px-3 py-2 bg-blue-600 text-white rounded-lg shadow-xs dark:bg-gray">
    //             {children}
    //         </div>
    //     </>
    // )
}
